import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ErrorBoundary } from '@dixa/lib-shared-habla';
import { lazy, Suspense } from 'react';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { KnowledgeErrorPlaceholder } from '../../../integrations/elevio/src/components/KnowledgeErrorPlaceholder';
const LazyLoadedKnowledgeCardHeaderWrapper = lazy(() => import('./KnowledgeCardHeaderWrapper'));
const LazyLoadedKnowledgeSuggestionsWrapper = lazy(() => import('./KnowledgeSuggestionsWrapper'));
const LazyLoadedElevioCardWrapper = lazy(() => import('./ElevioCardWrapper'));
export function SuggestionCards({ isMinimized, }) {
    const { elevioSuggestions, knowledgeSuggestions } = useFeatureFlag([
        'elevio-suggestions',
        'knowledge-suggestions',
    ]);
    return (_jsxs(ErrorBoundary, Object.assign({ fallback: _jsx(KnowledgeErrorPlaceholder, {}) }, { children: [_jsx(Suspense, Object.assign({ fallback: null }, { children: (elevioSuggestions || knowledgeSuggestions) && !isMinimized && (_jsx(LazyLoadedKnowledgeCardHeaderWrapper, {})) })), _jsx(Suspense, Object.assign({ fallback: null }, { children: knowledgeSuggestions && (
                /**
                 * Displayed 2nd - Do not reorder this JSX
                 *
                 * Also note that content within KnowledgeSuggestions is conditionally
                 * rendered depending on:
                 *
                 * - Whether the organisation has a knowledge base at all
                 * - Whether the organisation has linked a `queueId` with a
                 *   `collectionId` using the collectionUpdate mutation in the
                 *   Knowledge Management Graphql API. For an up to date API schema,
                 *   refer to
                 *   https://knowledge.euw1.stag.dixa.io/delivery/api/alpha/graphql
                 */ _jsx(LazyLoadedKnowledgeSuggestionsWrapper, { isMinimized: isMinimized })) })), _jsx(Suspense, Object.assign({ fallback: null }, { children: elevioSuggestions && (
                /**
                 * Displayed 3rd - Do not reorder this JSX
                 *
                 * Also note that content within LazyLoadedElevioSuggestions is
                 * conditionally rendered depending on:
                 *
                 * - Whether the organisation has an Elevio account at all
                 *
                 * If they don't have an account, we render an advertisement, see the
                 * `SuggestionsNotEnabledPlaceholder` component for more details.
                 */ _jsx(LazyLoadedElevioCardWrapper, { isMinimized: isMinimized })) }))] })));
}
